__turbopack_context__.v({
  "bottomListingContainer": "Listing-module__4CIipq__bottomListingContainer",
  "button": "Listing-module__4CIipq__button",
  "containerLower": "Listing-module__4CIipq__containerLower",
  "containerUpper": "Listing-module__4CIipq__containerUpper",
  "listings": "Listing-module__4CIipq__listings",
  "lowerContent": "Listing-module__4CIipq__lowerContent",
  "priceBadge": "Listing-module__4CIipq__priceBadge",
  "productContainer": "Listing-module__4CIipq__productContainer",
  "productImage": "Listing-module__4CIipq__productImage",
  "productImageContainer": "Listing-module__4CIipq__productImageContainer",
  "productImageHover": "Listing-module__4CIipq__productImageHover",
  "productName": "Listing-module__4CIipq__productName",
  "reviewsBadge": "Listing-module__4CIipq__reviewsBadge",
  "section": "Listing-module__4CIipq__section",
  "stars": "Listing-module__4CIipq__stars",
  "topListingContainer": "Listing-module__4CIipq__topListingContainer",
  "topTitle": "Listing-module__4CIipq__topTitle",
});
